import { render, staticRenderFns } from "./Clienttest.vue?vue&type=template&id=9945aede"
import script from "./Clienttest.vue?vue&type=script&lang=js"
export * from "./Clienttest.vue?vue&type=script&lang=js"
import style0 from "./Clienttest.vue?vue&type=style&index=0&id=9945aede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports